import translationService from '../../translationService';
import {FINISH_LOADING, START_LOADING} from '../actionTypes';

export const startLoading = isLoader => ({type: START_LOADING, isLoader});

export const finishLoading = () => ({type: FINISH_LOADING});

export const setLanguage = language => () => {
    translationService.setLanguage(language);
};
